/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_CLASSIC_ROADMAP } from './resourceTypeRoadmap.constants.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const classicRoadmapResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_CLASSIC_ROADMAP,
	getKey: ({ match }) => match.params.boardId || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-roadmap", jiraSpaEntry: "async-resource-roadmap" */ './getData.tsx'
		),
	isBrowserOnly: true,
});
